// extracted by mini-css-extract-plugin
export default {"container":"FileUploader_container__HEqLc"};